<template>
  <div class="animated fadeIn col-md-12">
    <b-row>
      <b-col cols="12">
        <b-card>
          <div class="text-center" v-show="isLoading">
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
          </div>
          <div slot="header">
            ایجاد
            <strong v-text="$lang.company"></strong>
          </div>
          <b-form @submit.prevent="save" v-show="!isLoading">
            <b-row>
              <b-col xs="12" md="12">
                <b-form-group
                  :label="$lang.company_name"
                  label-for="name"
                  :label-cols="12"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.name"
                    :rules="$v.name.$params"
                  />
                  <b-form-input
                    id="name"
                    type="text"
                    v-model="$v.name.$model"
                    :state="$v.name.$dirty ? !$v.name.$error : null"
                    :autocomplete="$lang.name"
                  ></b-form-input>
                  <b-form-invalid-feedback id="name-feedback"
                    >نام ضروری است</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>

              <b-col xs="12" md="12">
                <b-form-group
                  :label="$lang.parent"
                  label-for="parent_code_id"
                  :label-cols="$config.form.labelCol"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.parent"
                    :rules="$v.parent_code_selected.$params"
                  />
                  <selectAsync
                    :options="parent_code_options"
                    v-model="$v.parent_code_selected.$model"
                    label="name"
                    :isValid="
                      $v.parent_code_selected.$dirty
                        ? !$v.parent_code_selected.$error
                        : null
                    "
                    :loading="parent_code_Loading"
                    :asyncFind="getCompanyCombo"
                  />
                  <b-form-invalid-feedback
                    :style="{
                      display: $v.parent_code_selected.$error
                        ? 'block'
                        : 'none',
                    }"
                    id="parent_code_id_feedback"
                  >
                    {{ $lang.error_required | replace($lang.parent) }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="12">
                <b-form-group
                  class="p-0"
                  :label="$lang.organization_type"
                  :label-cols="$config.form.labelCol"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.organization_type"
                    :rules="$v.organization_type_selected.$params"
                  />
                  <selectFind
                    :options="organization_type_options"
                    v-model="$v.organization_type_selected.$model"
                    label="text"
                    :isValid="
                      $v.organization_type_selected.$dirty
                        ? !$v.organization_type_selected.$error
                        : null
                    "
                    :placeholder="$lang.organization_type"
                  />
                  <b-form-invalid-feedback
                    :style="{
                      display: $v.organization_type_selected.$error
                        ? 'block'
                        : 'none',
                    }"
                    id="gender_id-feedback"
                  >
                    {{
                      $lang.error_required | replace($lang.organization_type)
                    }}</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col xs="12" md="6">
                <b-form-group
                  :label="$lang.economic_code"
                  label-for="economic_code"
                  :label-cols="12"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.economic_code"
                    :rules="$v.economic_code.$params"
                  />
                  <b-form-input
                    id="economic_code"
                    v-model="economic_code"
                    type="text"
                    :autocomplete="$lang.economic_code"
                    :state="
                      $v.economic_code.$dirty ? !$v.economic_code.$error : null
                    "
                  ></b-form-input>
                  <b-form-invalid-feedback
                    v-if="!$v.economic_code.required"
                    id="name-feedback"
                  >
                    {{ $lang.error_required | replace($lang.economic_code) }}
                  </b-form-invalid-feedback>
                  <b-form-invalid-feedback
                    v-if="
                      $v.economic_code.required && !$v.economic_code.numeric
                    "
                    id="name-feedback"
                  >
                    {{ $lang.error_numeric | replace($lang.economic_code) }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col xs="12" md="6">
                <b-form-group
                  :label="$lang.national_id"
                  label-for="national_id"
                  :label-cols="12"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.national_id"
                    :rules="$v.national_id.$params"
                  />
                  <b-form-input
                    id="national_id"
                    v-model="national_id"
                    type="text"
                    :autocomplete="$lang.national_id"
                    :state="
                      $v.national_id.$dirty ? !$v.national_id.$error : null
                    "
                  ></b-form-input>
                  <b-form-invalid-feedback
                    v-if="!$v.national_id.required"
                    id="name-feedback"
                  >
                    {{ $lang.error_required | replace($lang.national_id) }}
                  </b-form-invalid-feedback>
                  <b-form-invalid-feedback
                    v-if="$v.national_id.required && !$v.national_id.numeric"
                    id="name-feedback"
                  >
                    {{ $lang.error_numeric | replace($lang.national_id) }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col xs="12" md="12">
                <b-form-group
                  :label="$lang.registration_code"
                  label-for="registration_code"
                  :label-cols="12"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.registration_code"
                    :rules="$v.registration_code.$params"
                  />
                  <b-form-input
                    id="registration_code"
                    v-model="registration_code"
                    type="text"
                    :autocomplete="$lang.registration_code"
                    :state="
                      $v.registration_code.$dirty
                        ? !$v.registration_code.$error
                        : null
                    "
                  ></b-form-input>
                  <b-form-invalid-feedback
                    v-if="!$v.registration_code.required"
                    id="name-feedback"
                  >
                    {{
                      $lang.error_required | replace($lang.registration_code)
                    }}
                  </b-form-invalid-feedback>
                  <b-form-invalid-feedback
                    v-if="
                      $v.registration_code.required &&
                      !$v.registration_code.numeric
                    "
                    id="name-feedback"
                    >{{
                      $lang.error_numeric | replace($lang.registration_code)
                    }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col xs="12" md="12">
                <b-form-group
                  :label="$lang.description"
                  label-for="description"
                  :label-cols="12"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.description"
                    :rules="$v.description.$params"
                  />
                  <b-form-textarea
                    id="description"
                    v-model="$v.description.$model"
                    :rows="3"
                  ></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
            <div slot="footer" class="form-group form-btn">
              <b-button type="submit" size="md" variant="success">
                {{ $lang.submitButton }}
                <i class="fa fa-check"></i>
              </b-button>
              <b-button
                type="reset"
                class="ml-2"
                size="md"
                variant="danger"
                @click="handleBack"
              >
                {{ $lang.cancelButton }}
                <i class="fa fa-ban"></i>
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required, numeric } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { renderEumOptions } from "@/shared/utils";

export default {
  name: "add-company",
  validations: {
    name: {
      required,
    },
    description: {},
    economic_code: {
      numeric,
    },
    national_id: {
      numeric,
    },
    registration_code: {
      numeric,
    },
    parent_code_selected: {
      required,
    },
    organization_type_selected: { required },
  },
  props: {
    isModal: {
      type: Boolean,
      default: false,
    },
    backUrl: {
      type: String,
      default: "",
    },
    parentRefrence: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isLoading: false,
      name: "",
      economic_code: "",
      national_id: "",
      registration_code: "",
      description: "",
      content: "",
      parent_code_selected: null,
      parent_code_options: [],
      parent_code_Loading: false,
      organization_type_selected: null,
    };
  },
  computed: {
    organization_type_options() {
      return renderEumOptions("organization_type");
    },
  },
  methods: {
    pathOr,
    renderEumOptions,
    handleBack() {
      if (this.isModal) {
        this.$emit("modal-end-up");
      } else {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push("/");
      }
    },
    clear() {
      this.name = "";
      this.economic_code = "";
      this.national_id = "";
      this.registration_code = "";
      this.description = "";
    },
    afterSave() {
      if (this.backUrl) {
        this.$route.push(this.backUrl);
      } else {
        this.handleBack();
      }
    },
    save() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }
      this.isLoading = true;

      let payload = {
        name: this.name,
        economic_code: this.economic_code,
        national_id: this.national_id,
        registration_code: this.registration_code,
        description: this.description,
        parent_code: pathOr(null, ["code"], this.parent_code_selected),
        organization_type_id: pathOr(
          null,
          ["value"],
          this.organization_type_selected
        ),
      };
      this.$httpService
        .post(this.$config.api_url + this.$config.resources.company, payload)
        .then((response) => {
          this.isLoading = false;
          this.$notify.success(response.data.message);
          this.afterSave();
          this.$emit("getData");
        })
        .catch((err) => {
          this.isLoading = false;
          this.$notify.error(err.response.data.message);
        });
    },
    async getCompanyCombo(query) {
      if (!query || query.length < 2) {
        return;
      }
      if (query.length > 2) {
        this.parent_code_options = [];
      }

      try {
        this.parent_code_Loading = true;
        const url = `${this.$config.api_url}${this.$config.profile.company_combo}?search_txt=${query}`;
        const response = await this.$httpService.get(url);
        this.parent_code_options = pathOr([], ["data", "data"], response);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.parent_code_Loading = false;
      }
    },
  },
};
</script>

<style scoped lang="css">
.btn {
  margin-bottom: 4px;
}
</style>
